module.exports = __webpack_public_path__ + "img/bank_card.d4017db3.png";